import "./PlumnoteLegalPage.css";
import { Link } from "react-router-dom";

// Shared renderer for Plumnote's Privacy Policy and Terms of Service: both
// are a title, an intro paragraph, and a list of {heading, paragraphs?, list?,
// footNote?} sections — richer than the hub's generic one-paragraph
// Privacy/Terms pages, because Plumnote's real policy needs real sections.
function PlumnoteLegalPage({ data: { title, updated, intro, sections, btnBack } }) {
  return (
    <>
      <main className="pnl-container">
        <div className="pnl-back">
          <h3>
            {/* Absolute, not relative: these routes are flat siblings in
                App.jsx, so a relative ".." would resolve to "/" (route-tree
                mode), skipping the Plumnote product page. */}
            <Link to="/plumnote">{btnBack}</Link>
          </h3>
        </div>
        <section className="pnl-title">
          <h2>{title}</h2>
          <p className="pnl-updated">{updated}</p>
          {intro && <p className="pnl-intro">{intro}</p>}
        </section>
        {sections.map((section, index) => (
          <section className="pnl-section" key={index}>
            <h3>{section.heading}</h3>
            {section.paragraphs?.map((p, i) => <p key={i}>{p}</p>)}
            {section.list && (
              <ul>
                {section.list.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            )}
            {section.footNote && (
              <p className="pnl-footnote">{section.footNote}</p>
            )}
          </section>
        ))}
      </main>
    </>
  );
}

export default PlumnoteLegalPage;
